import { AudioButton, Hint, Timer } from "./common";
import { BLOCKS } from "./blocks";
import * as styled from "./SlideFrame.styled";
import mascot from "../../assets/icons/lamp.svg";

// Оформлення слайда: розділ, заголовок, інструкція з UA-підказкою, аудіо й таймер; тіло — за типом
function SlideFrame({ slide, showAnswers, lesson }) {
  const Block = BLOCKS[slide.type];

  if (!Block) {
    // Найчастіше — відкрита стара версія сторінки (новий тип блока зʼявився після оновлення платформи)
    return (
      <styled.Unknown>
        <b>Цей слайд потребує новішої версії платформи</b>
        <span>Оновіть сторінку: Ctrl+Shift+R (на Mac — Cmd+Shift+R)</span>
        <button type="button" onClick={() => window.location.reload()}>
          Оновити
        </button>
      </styled.Unknown>
    );
  }

  if (Block.fullBleed) {
    return (
      <styled.Frame $section={slide.section}>
        <Block slide={slide} showAnswers={showAnswers} lesson={lesson} />
      </styled.Frame>
    );
  }

  const timerSec = slide.data?.timerSec;

  return (
    <styled.Frame $section={slide.section}>
      <styled.Decor />
      {/* Маскот Speaksy — лампочка — на слайдах з правилами граматики */}
      {slide.type === "grammar" && <styled.Mascot src={mascot} alt="" />}
      <styled.Header>
        <styled.HeaderText>
          {slide.section && <styled.Section $section={slide.section}>{slide.section}</styled.Section>}
          {slide.title && <styled.Title>{slide.title}</styled.Title>}
          {slide.instruction && (
            <styled.Instruction>
              <Hint ua={slide.ua}>{slide.instruction}</Hint>
            </styled.Instruction>
          )}
        </styled.HeaderText>
        <styled.HeaderTools>
          {timerSec && <Timer seconds={timerSec} />}
          <AudioButton audio={slide.audio} />
        </styled.HeaderTools>
      </styled.Header>
      <styled.Body>
        <Block slide={slide} showAnswers={showAnswers} lesson={lesson} />
      </styled.Body>
    </styled.Frame>
  );
}

export default SlideFrame;
